export default class Accordions {
  constructor(accordionBtn) {
    this.$ = accordionBtn;
    this.wrapper = this.$.closest('.js-acc');
    this.content = this.wrapper.querySelector('.js-acc-cont');
    // this.contentHeight = this.content.scrollHeight + 'px';
    this.contentHeight = this.content.scrollHeight;
    this.condition = this.$.getAttribute('aria-expanded');
    this.clickId = this.$.getAttribute('data-clickID');
    if(this.$.closest('.js-acc-cover')){
      this.cover = this.$.closest('.js-acc-cover');
      this.btnSetting = this.cover.dataset.remove;
      this.duration = this.cover.dataset.duration;
    }
    this.flagClass = 'm-opened';
    this.defHeight = this.content.dataset.defheight ? this.content.dataset.defheight : '0px';
    this.initialize();
    this.bind();
  }

  initialize() {
    this.content.style.overflow = 'hidden';
    if(this.condition == 'true'){//open
      // this.content.style.maxHeight = this.contentHeight;
      if(window.outerWidth > 768) {
        this.content.style.maxHeight = this.contentHeight + 'px';
      } else {
        this.content.style.maxHeight = this.contentHeight/2 + 'vw';
      }
      this.wrapper.classList.add(this.flagClass);
    }else{//close
      // this.content.style.maxHeight = this.defHeight;
      if(window.outerWidth > 768) {
        this.content.style.maxHeight = this.defHeight + 'px';
      } else {
        this.content.style.maxHeight = this.defHeight/7.3 + 'vw';
      }
      this.wrapper.classList.remove(this.flagClass);
      this.$.setAttribute('aria-expanded','false');
    }
  }

  bind() {
    this.$.addEventListener('click', this.accordionToggle.bind(this));
  }

  accordionToggle() {
    if(this.$.getAttribute('aria-expanded') == 'false'){//open
      // this.content.style.maxHeight = this.contentHeight;
      if(window.outerWidth > 768) {
        this.content.style.maxHeight = this.contentHeight + 'px';
      } else {
        this.content.style.maxHeight = this.contentHeight/2 + 'vw';
      }
      this.wrapper.classList.add(this.flagClass);
      this.$.setAttribute('aria-expanded','true');
      this.$.setAttribute("onclick","_sc.gene_click('','');");
      if(this.$.closest('.sec_special')) {
        this.$.innerHTML = "閉じる";
      }
      if(this.btnSetting == 'true'){
        if(this.duration){
          setTimeout(() => {
            this.cover.style.display = 'none';
          }, this.duration);
        }else{
          this.cover.style.display = 'none';
        }
      }
    }else{//close
      // this.content.style.maxHeight = this.defHeight;
      if(window.outerWidth > 768) {
        this.content.style.maxHeight = this.defHeight + 'px';
      } else {
        this.content.style.maxHeight = this.defHeight/7.3 + 'vw';
      }
      this.wrapper.classList.remove(this.flagClass);
      this.$.setAttribute('aria-expanded','false');
      this.$.setAttribute("onclick","_sc.gene_click('" + this.clickId + "','');");
      if(this.$.closest('.sec_special')) {
        this.$.innerHTML = "もっと見る";      
        this.wrapper = this.$.closest('.js-acc');
        window.scrollTo({
          top: this.wrapper.getBoundingClientRect().top + window.pageYOffset,
          behavior: 'smooth',
        });
      }
    }
  }

}

